import { TFileSizeInfo } from 'types/file';
import { isImageFile, isVideoFile } from './file';

const getFileSize = (file: File): Promise<TFileSizeInfo> => {
  return new Promise<TFileSizeInfo>((resolve) => {
    const url = URL.createObjectURL(file);

    const cleanup = () => {
      URL.revokeObjectURL(url);
    };

    if (isImageFile(file)) {
      const image = new Image();
      image.src = url;

      image.onload = () => {
        resolve({
          originalHeight: image.naturalHeight,
          originalWidth: image.naturalWidth,
        });
        cleanup();
      };

      image.onerror = () => {
        resolve({});
        cleanup();
      };

      return;
    }

    if (isVideoFile(file)) {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.src = url;

      video.onloadedmetadata = () => {
        resolve({
          originalHeight: video.videoHeight,
          originalWidth: video.videoWidth,
        });
        cleanup();
      };

      video.onerror = () => {
        resolve({});
        cleanup();
      };

      return;
    }

    resolve({});
    cleanup();
  });
};

export default getFileSize;
